import racingModule from './racing';
import footballModule from './football';

let modules = [racingModule, footballModule];

export default modules;



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/modules/index.js